import { useMediaQuery, useTheme } from '@mui/material'
import { graphql, useStaticQuery } from 'gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import { PAGE_PADDING_TOP, PAGE_PADDING_TOP_MOBILE } from '../constants/sizes'
import { useWindowWidth } from './useWindowSize'

export const useRegisterPageImages = () => {
  const windowWidth = useWindowWidth()

  const { mobileImage, desktopImage } = useStaticQuery<{
    desktopImage: {
      childImageSharp: {
        gatsbyImageData: IGatsbyImageData
      } | null
      placeholder: {
        gatsbyImageData: IGatsbyImageData
      } | null
    }
    mobileImage: {
      childImageSharp: {
        gatsbyImageData: IGatsbyImageData
      } | null
      placeholder: {
        gatsbyImageData: IGatsbyImageData
      } | null
    }
  }>(graphql`
    query {
      desktopImage: file(relativePath: { eq: "raster/register_card_group_desktop.png" }) {
        childImageSharp {
          gatsbyImageData(width: 1978, placeholder: NONE)
        }
      }
      mobileImage: file(relativePath: { eq: "raster/register_card_group_mobile.png" }) {
        childImageSharp {
          gatsbyImageData(width: 763, placeholder: NONE)
        }
      }
    }
  `)
  const theme = useTheme()
  const maxImageWidths = {
    xs: '100%',
    md: `calc(100vw - (${parseInt(theme.spacing(4))}px + 380px))`,
    xl: '100%'
  }
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isMd = useMediaQuery(theme.breakpoints.down('md'))
  const isXl = useMediaQuery(theme.breakpoints.up('xl'))

  const imageHeight = isMd
    ? mobileImage.childImageSharp.gatsbyImageData.height
    : desktopImage.childImageSharp.gatsbyImageData.height

  const imageWidth = isMd
    ? mobileImage.childImageSharp.gatsbyImageData.width
    : desktopImage.childImageSharp.gatsbyImageData.width

  const ratio = imageHeight / imageWidth

  const transformAmountX = isMd ? 46 : 48.5
  const transformAmountY = isMd ? 25 : 35

  const renderedWidth = isMd
    ? windowWidth - (parseInt(theme.spacing(4)) + 128)
    : isXl
      ? 1100
      : windowWidth - (parseInt(theme.spacing(4)) + 380)

  const renderedHeight = ratio * renderedWidth

  const headerOffset = isMobile ? PAGE_PADDING_TOP_MOBILE : isMd ? 96 : PAGE_PADDING_TOP
  const whiteSpaceOffset = isMd ? 0.7825 : 0.75

  const pageSpacing = `${((100 - transformAmountY) / 100) * whiteSpaceOffset * renderedHeight - headerOffset}px`

  const headerTransform = `translateX(-${transformAmountX}%) translateY(-${transformAmountY}%)`
  // const headerTransform = `translateY(0%)`

  const image = isMd ? mobileImage : desktopImage
  return {
    maxImageWidths,
    headerTransform,
    renderedWidth,
    renderedHeight,
    pageSpacing,
    imageHeight,
    mobileImage,
    image
  }
}
